import { render } from "./Quarterly.vue?vue&type=template&id=5c090986&scoped=true"
import script from "./Quarterly.vue?vue&type=script&lang=js"
export * from "./Quarterly.vue?vue&type=script&lang=js"

import "./Quarterly.vue?vue&type=style&index=0&id=5c090986&scoped=true&lang=css"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c090986"]])

export default __exports__